(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jm-newsletter-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jm-newsletter-offer')) {
    customElements.define('jm-newsletter-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const card = this.querySelector('.jm-welcome__card');
        const opener = this.querySelector('[data-welcome-open]');
        const form = this.querySelector('form');
        const key = 'jm-newsletter-welcome';
        const success = this.querySelector('[data-welcome-success]');
        const errors = this.querySelector('[data-welcome-error]');
        const open = () => { if (!dialog.open) dialog.showModal(); };
        opener.addEventListener('click', open);
        this.querySelector('[data-welcome-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const box = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
        });
        form.addEventListener('submit', () => { try { sessionStorage.setItem(key + '-pending', window.location.pathname); } catch {} });
        let pending = false;
        try {
          pending = sessionStorage.getItem(key + '-pending') === window.location.pathname;
          if (localStorage.getItem(key) === 'complete') card.hidden = true;
        } catch {}
        if (success && pending) {
          open();
          success.focus();
          card.hidden = true;
          try { localStorage.setItem(key, 'complete'); sessionStorage.removeItem(key + '-pending'); } catch {}
        } else if (errors && pending) {
          open();
          errors.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
